module.exports = __webpack_public_path__ + "gfx/fall_sensor_001.png";